<script>
import overflowScroller from '@/components/view/overflow-scroller'
export default {
  components: {
    'overflow-scroller': overflowScroller
  },
  props: {
    storyId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    galleryIndex: 0,
    intervalId: null,
    timeoutId: null,
    galleryPosition: 0
  }),
  computed: {
    story () {
      let docs

      if (this.$route.meta.version === 'raz') {
        docs = this.docs.razstory
      } else {
        docs = this.docs.story
      }

      return docs[this.storyId]
    }
  },
  mounted () {
    this.intervalId = setInterval(() => {
      const index = (this.galleryIndex + 1) % 10
      this.setIndex(index, true)
    }, 3000)
  },
  destroyed () {
    clearTimeout(this.timeoutId)
    clearInterval(this.intervalId)
  },
  methods: {
    setIndex (index, flg) {
      if (!flg) {
        this.cancelAutoScroll({})
      }
      const width = this.$refs.gallery.clientWidth
      this.galleryPosition = width * index
    },
    setPos (val) {
      const width = this.$refs.gallery.clientWidth
      this.galleryIndex = Math.round(val / width)
    },
    cancelAutoScroll (e) {
      if (e.deltaX < e.deltaY) {
        return false
      }
      if (this.intervalId) {
        clearTimeout(this.timeoutId)
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    }
  }
}
</script>

<template>
  <div class="gp-story-article transition-item">
    <article>
      <header class="has-text-weight-bold">
        <h1>
          <template v-if="$route.meta.version === 'raz'">
            <span class="case is-family-oswald">{{ story.title }}</span>
          </template>

          <template v-else>
            <span class="case is-family-oswald">{{ story.caseId }}</span>
            <span class="title">{{ story.title }}</span>
          </template>
        </h1>
        <div
          class="gallery"
          ref="gallery"
          @wheel="cancelAutoScroll"
          @touchmove="cancelAutoScroll"
        >
          <overflow-scroller
            class="gallery-view"
            :position="galleryPosition"
            @setPos="setPos"
          >
            <ul class="image-list">
              <li
                v-for="(image, index) in story.images"
                :key="index"
              >
                <figure><img :src="image" :alt="'CASE' + storyId + '-' + (index + 1)"></figure>
              </li>
            </ul>
          </overflow-scroller>
          <nav class="gallery-nav">
            <ul class="level-center is-mobile">
              <li
                :class="{current: index === galleryIndex}"
                v-for="(image, index) in story.images"
                :key="index"
                @pointerdown="setIndex(index)"
              >
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                </svg>
              </li>
            </ul>
          </nav>
        </div>
        <h2 class="level is-mobile is-family-oswald">
          <span class="number">
            <template v-if="$route.meta.version === 'raz'">Intermission</template>{{ story.no }}
          </span>
          <span class="sub-title is-size-4 is-size-6-mobile">{{ story.subTitle }}</span>
        </h2>
      </header>
      <div
        class="text is-size-4 is-size-5-mobile"
        v-html="story.text"
      ></div>
    </article>
  </div>
</template>

<style lang="scss">
.gp-story-article {
  .scroll-container {
    @include is-not-mobile {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.gp-story-article {
  article {
    h1 {
      color: $yellow;
    }
    h2 {
      background-color: $black;
      color: $yellow;
      padding: .5rem 1rem .5rem 1.5rem;
    }
    .text {
      background-color: $white-transparent;
      padding: 1.5rem;
      line-height: 1.75rem;
    }
    .gallery {
      position: relative;
      .gallery-view {
        width: 100%;
        position: relative;
        top: 1px;
        @include is-not-mobile {
          padding-top: 56.25%;
        }
        ul.image-list {
          width: 100%;
          display: flex;
          align-items: center;
          li {
            min-width: 100%;
          }
        }
        figure {
          width: 100%;
          background-color: $black;
        }
      }
      .gallery-nav {
        position: absolute;
        bottom: 0;
        @include is-mobile {
          bottom: 0;
        }
        left: 0;
        width: 100%;
        z-index: 2;
        li {
          cursor: pointer;
          color: $black-transparent;
          padding: .375rem;
          @include is-mobile {
            padding: .125rem .375rem;
          }
          svg {
            @include is-mobile {
              width: .75rem;
              height: .75rem;
            }
            @include is-not-mobile {
              width: 1rem;
              height: 1rem;
            }
          }
          &.current {
            color: $yellow;
          }
        }
      }
    }
    @include is-mobile {
      h1 {
        font-size: 2.25rem;
        line-height: 2.5rem;
        padding: 1.5rem 1.5rem 1rem;
        .case {
          display: block;
        }
      }
      .number {
        font-size: 2.5rem;
      }
      .text {
        padding: 1rem 1.5rem;
        line-height: 1.375rem;
      }
    }
    @include is-not-mobile {
      h1 {
        font-size: 2.75rem;
        padding: 1rem 0 .5rem;
        .case {
          padding-right: 1.5rem;
        }
      }
      .number {
        font-size: 3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/story/story-article.vue